import { Label } from "./Label/Label";

interface PropsData {
  title: string;
  flag: boolean;
  data: any;
  isArray: boolean;
}

const ErrorComponent = ({ title, flag, isArray, data }: PropsData) => {
  const isEmptyArray = isArray && (!data || data.length === 0);
  const isInvalidValue = !isArray && (data === null || data === undefined || data === "");

  return (
    <>
      {flag && (isEmptyArray || isInvalidValue) && (
        <Label modeError={true} title={title} />
      )}
    </>
  );
};

export default ErrorComponent;
